<template>
<div />
	<!-- <div class="user-info flex flex-col sm:flex-row justify-between pb-4">
		<div
			class="
        bg-white
        text-black
        py-6
        sm:mr-4
		mb-4
		sm:mb-0
        sm:p-4
        w-full
        sm:w-1/3
        text-center
        sm:text-left
      "
		>
			<div class="font-bold">Your Information</div>
			<div class="capitalize">
				<span>Name: </span>
				<span
					>{{ user.apiData.Profile.FirstName }}
					{{ user.apiData.Profile.LastName }}</span
				>
			</div>
			<div class="">
				<span>Employee ID: </span>
				<span>{{ user.apiData.Profile.EmployeeId }}</span>
			</div>
			<div class="">
				<span>Company: </span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'CHR'">
					Alberta Health Services
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'CW'">
					Carewest
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'COV'">
					Covenant Health
				</span>
				<span v-if="user.apiData.Profile.PayrollSelection === 'LAB'">
					Alberta Precision Labs
				</span>
			</div>
			<div class="">
				<span>Email: </span>
				<span>{{ user.apiData.Profile.EmailAddress }}</span>
			</div>
			<div v-if="user.data.emailVerified !== true" class="">
				<span>Your Email has not been verified.</span>
			</div>
		</div>
		<div
			class="
        bg-white
        text-black
        py-6
        sm:mr-4
		mb-4
		sm:mb-0
        sm:p-4
        w-full
        sm:w-1/3
        text-center
        sm:text-left
      "
		>
			<div class="flex flex-col sm:flex-row justify-center sm:justify-between">
				<span class="font-bold">Contact Information</span>
				<span class="text-right pr-1 sm:text-center sm:pr-0"
					><router-link to="/settings#form-top"><i class="fas fa-edit"></i></router-link
				></span>
			</div>
			<div v-if="user.apiData.Profile.HomePhone">
				<span>Home Phone: </span>
				<span
					>({{ user.apiData.Profile.HomePhone.slice(0, 3) }})
					{{ user.apiData.Profile.HomePhone.slice(3, 6) }}-{{
						user.apiData.Profile.HomePhone.slice(6, 10)
					}}</span
				>
			</div>
			<div v-if="user.apiData.Profile.MobilePhone">
				<span>Mobile Phone: </span>
				<span
					>({{ user.apiData.Profile.MobilePhone.slice(0, 3) }})
					{{ user.apiData.Profile.MobilePhone.slice(3, 6) }}-{{
						user.apiData.Profile.MobilePhone.slice(6, 10)
					}}</span
				>
			</div>
			<div class="">
				<span>Street Address: </span>
				<span>{{ user.apiData.Profile.AddressLineOne }}</span>
			</div>
			<div class="">
				<span>City/Province: </span>
				<span class="capitalize"
					>{{ user.apiData.Profile.City }},
					{{ user.apiData.Profile.Province }}</span
				>
			</div>
			<div class="">
				<span>Postal Code: </span>
				<span class="uppercase">{{ user.apiData.Profile.PostalCode }}</span>
			</div>
		</div>
		<div
			class="
        bg-white
        text-black
        py-6
		mb-4
		sm:mb-0
        sm:p-4
        w-full
        sm:w-1/3
        text-center
        sm:text-left
      "
		>
			<div class="font-bold">Participation History</div>
			<div class="">
				<span>Registration Date: </span>
				<span>{{ dateTime(user.apiData.Profile.OptInDate) }}</span>
			</div>
			<div
				v-if="
					user.apiData.Profile.CurrentDesignation ||
						user.apiData.Profile.NewDesignation
				"
			>
				Proceeds Benefitting:
				{{
					user.apiData.Profile.CurrentDesignation ||
						user.apiData.Profile.NewDesignation
				}}
			</div>
			<div v-else>
				Support of the WinWin Staff Lottery has contributed more than
				<span class="font-bold winwin-gold2">$6.1 Million</span> to help enhance
				healthcare across Alberta!
			</div>
		</div>
	</div> -->
	<!-- <div
		v-if="this.pay !== null && this.loading === false && this.pay.length > 0"
		class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full"
	>
		<div class="font-bold">Deduction History</div>
		<div
			v-for="period in pay"
			v-bind:key="period.Id"
			class="block sm:inline-block w-1/1 sm:w-2/4 my-1.5"
		>
			<div class="font-bold">{{ dateTime(period.PayPeriodDate) }}</div>
			<div>
				<div v-if="period.DeductionMain !== ''">
					Main Lottery Deduction: ${{ period.DeductionMain }}
				</div>
				<div v-if="period.Deduction5050 !== ''">
					50/50 Lottery Deduction: ${{ period.Deduction5050 }}
				</div>
				<div v-if="period.Deduction5050 !== '' && period.DeductionMain !== ''">
					Total Deduction: ${{ parseInt(period.Deduction5050) + parseInt(period.DeductionMain) }}
				</div>
				<div v-if="new Date(period.PayPeriodDate) <= date">Deduction Made</div>
				<div v-else>No Deduction Made Yet!</div>
			</div>
		</div>
	</div>
	<div
		v-else-if="this.loading === false && this.pay.length === 0"
		class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full"
	>
		No Previous Deductions Made
	</div>
	<div v-else class="pay-periods bg-white text-black py-6 sm:mr-4 sm:p-4 w-full">
		<Loading />
	</div> --> 
</template>
<script>
	import moment from "moment";

	import Loading from "@/components/Loading";

	import { getUserPayPeriod } from "@/utils/api";

	export default {
		name: "UserInfo",
		props: ["user"],
		components: {
			Loading,
		},
		data() {
			return {
				pay: null,
				loading: true,
				date: null,
			};
		},
		async created() {
			this.date = new Date();

			const token = this.$props.user.token;
			const userId = this.$props.user.apiData.UserId;

			const res = await getUserPayPeriod(token, userId);

			if (res.Success) {
				this.pay = res.Data;
				this.loading = false;
			} else {
				this.pay = "";
				this.loading = false;
			}
		},
		methods: {
			dateTime(value) {
				// format Date object to readible format
				return moment(value).format("MMMM Do, YYYY");
			},
		},
	};
</script>
